import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import React from 'react';
import MainLayout from './MainLayout';
import { useSelector } from 'react-redux';
import { getCombineRoute } from 'utility/route';

const MainRouter = () => {
    const userRole = useSelector((state) => state.user.role);
    const menu = useSelector((state) => state.menu);
    const combineRoute = getCombineRoute(menu, userRole);

    return (
        <Router>
            <MainLayout>
                <Switch>
                    {combineRoute.map((route, index) => {
                        const Content = route.component;

                        let path = route.path;

                        // case when sub routing exist
                        if (route.subRoute?.length >= 1) {
                            return route.subRoute.map((item) => {
                                const SubRouteComponent = item.component;

                                return (
                                    <Route key={`${path}-${item.path}`} path={`${path}${item.path}`}>
                                        <SubRouteComponent name={item.name} />
                                    </Route>
                                );
                            });
                        }

                        // case without sub routing
                        return (
                            <Route key={`${index}-${route.path}`} path={route.path} exact={route.exact}>
                                <Content />
                            </Route>
                        );
                    })}
                </Switch>
            </MainLayout>
        </Router>
    );
};

export default MainRouter;
